import Select from 'react-select';

import _ from 'lodash';

import { getStyles } from '../helpers/random-form-helpers';

const ReactSelectPorts = ({
  field,
  form,
  options,
  placeholder = 'Select',
  onInputChange,
  isLoading,
  disabled,
  onChange,
  getSpecificValue,
  ...rest
}) => {
  const getValue = () => {
    if (options.length) {
      return options.find(
        (option) => option.unlocode === (field.value && field.value.unlocode)
      );
    } else {
      return !_.isEmpty(field.value) ? field.value : null;
    }
  };

  const { setFieldValue, handleBlur, errors, touched } = form;
  const customStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 9999, // ensures dropdown appears above siblings
      position: 'absolute',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '0.8rem', // change this value to the desired font size
      backgroundColor: state.isFocused ? '#DCE7F5' : '#FFFFFF',
      color: '#000000',
    }),
  };

  return (
    <Select
      classNamePrefix="react-select"
      menuPosition="absolute"
      styles={customStyles}
      options={options}
      name={field.name}
      getOptionLabel={(option) =>
        option.label || option.name + ', ' + option.countryCode
      }
      getOptionValue={(option) => option.unlocode}
      isLoading={isLoading}
      className={
        touched[field.name] && getStyles(errors, field.name)
          ? 'react-select-container error'
          : 'react-select-container'
      }
      value={getValue()}
      onChange={(option) => {
        if (onChange) {
          onChange(option);
        }
        getSpecificValue
          ? setFieldValue(field.name, option[getSpecificValue])
          : setFieldValue(field.name, option);
      }}
      onInputChange={onInputChange}
      onBlur={() => handleBlur({ target: { name: field.name } })}
      placeholder={placeholder}
      isDisabled={disabled}
      isClearable
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#033272',
        },
      })}
      {...rest}
    />
  );
};

export default ReactSelectPorts;
